import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

import TablesModule from "./modules/tables/index";
import UsersModule from "./modules/users/index";
import ChatModule from "./modules/chat/index";
import SocketModule from "./modules/socket/index";
import VideoChatModule from "./modules/videoChat/index";
import InvitesModule from "./modules/invites/index";
import RoomModule from "./modules/room/index";
import EventModule from "./modules/event/index";
import ConfigModule from "./modules/config/index";
import PhotoWallModule from "./modules/photoWall/index";
import CallsModule from "../modules/calls/store";

Vue.use(Vuex);

let store = new Vuex.Store({
  state: Object.assign({}, state),
  mutations: Object.assign({}, mutations),
  actions: Object.assign({}, actions),
  getters: Object.assign({}, getters),
  modules: {
    event: EventModule,
    config: ConfigModule,
    tables: TablesModule,
    users: UsersModule,
    chat: ChatModule,
    socket: SocketModule,
    videoChat: VideoChatModule,
    invites: InvitesModule,
    room: RoomModule,
    photoWall: PhotoWallModule,
    calls: CallsModule
  }
});

store.subscribeAction({
  before: (action, state) => {
    state.requestCounter++;
  },
  after: (action, state) => {
    state.requestCounter--;
  },
  error: (action, state, error) => {
    state.requestCounter--;
    // eslint-disable-next-line no-console
    console.error(`Action "${action.type}" failed with ${error}`);
  }
});

export default store;
